<template>
    <div>
      <h1 class="mt-5">Camera Capture</h1>
  
      <div>
        <video ref="video" width="640" height="480" autoplay muted style="border-radius: 16px;
border: 10px solid #fff;
background: rgba(255, 255, 255, 0.90);max-width:1000px;"></video>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "CameraCapture",
    data() {
      return {
        videoStream: null,
      };
    },
    mounted() {
      this.initializeCamera();
      setInterval(this.sendFrame, 200); // Capture frames at intervals
    },
    beforeDestroy() {
      // Cleanup the camera stream if the component is destroyed
      if (this.videoStream) {
        const tracks = this.videoStream.getTracks();
        tracks.forEach((track) => track.stop());
      }
    },
    methods: {
      // Initialize camera and start the video stream
      initializeCamera() {
        const video = this.$refs.video;
  
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) {
          alert("Camera access is not supported by this browser. Please try a different browser.");
          return;
        }
  
        navigator.mediaDevices
          .getUserMedia({ video: true })
          .then((stream) => {
            this.videoStream = stream;
            video.srcObject = stream;
          })
          .catch((error) => {
            console.error("Error accessing the camera:", error);
          });
      },
  
      // Capture and send the frame
      sendFrame() {
        const video = this.$refs.video;
  
        // Only proceed if the video is playing
        if (video.paused || video.ended) return;
  
        const canvas = document.createElement('canvas');
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        const context = canvas.getContext('2d');
        context.drawImage(video, 0, 0, canvas.width, canvas.height);
  
        canvas.toBlob((blob) => {
          const formData = new FormData();
          formData.append('file', blob, 'frame.jpg');
  
          // Sending the frame via a POST request
          fetch('https://cellnet.mywire.org/process_frame', {
            method: 'POST',
            body: formData
          }).catch((error) => console.error("Error sending frame:", error));
        }, 'image/jpeg');
      }
    }
  };
  </script>
  
  <style scoped>
  /* You can add styles here if needed */
  h1 {
    text-align: center;
    margin-top: 20px;
  }
  
  video {
    display: block;
    margin: 20px auto;
  }
  </style>
  